var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.381C24 19.2188 18.4615 25.7143 12 30C5.07692 25.2381 0 19.2188 0 12.381C0 5.54314 5.37258 0 12 0C18.6274 0 24 5.54314 24 12.381Z",
    fill: "#000032"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 30
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.381C24 19.2188 18.4615 25.7143 12 30C5.07692 25.2381 0 19.2188 0 12.381C0 5.54314 5.37258 0 12 0C18.6274 0 24 5.54314 24 12.381Z",
    fill: "#000032"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84724 15.7361C8.37687 15.3236 9.35363 14.6153 10.0579 13.7808C9.75672 13.6374 9.304 13.3366 8.80564 12.7984C7.83181 11.7466 6.60604 11.0303 5.07018 10.3322C3.87339 9.78823 1.5886 9.2805 -0.115931 9.02663H6.70218C7.42272 9.02663 8.07169 9.31295 9.28903 9.85003L9.31337 9.86076C10.0871 10.2021 11.0601 10.6401 11.7004 10.9298C11.7267 10.8755 11.753 10.8214 11.7795 10.7675C12.795 8.70031 14.3907 8.7729 15.1523 9.35316C15.6745 9.41118 15.9501 9.71577 16.0227 9.93341C15.6036 9.8689 14.8809 9.86746 14.2568 11.0087C15.3534 10.9496 16.5237 10.8928 17.2195 10.8762C18.498 10.8458 19.442 11.2602 20.8509 11.8786C21.1206 11.9969 21.4072 12.1228 21.7165 12.2544C23.421 12.9797 25.6333 13.5962 26.6488 13.8138C26.2257 13.7776 24.509 13.56 23.7112 13.4149C22.2557 13.1502 20.7011 12.8709 18.9965 12.9434C17.292 13.016 15.2973 13.6687 14.4995 13.9589C13.9343 14.1644 13.0811 14.2903 12.5993 14.3416C12.0925 15.4537 11.656 16.8394 11.5256 19C10.9091 17.7669 9.53096 16.2075 6.84724 15.7361ZM22.4781 13.5237C20.3892 13.2626 18.5734 13.5237 17.9448 13.705C18.6422 13.705 19.3182 13.8767 19.8902 14.022C20.0618 14.0655 20.224 14.1067 20.3747 14.1402C20.5378 14.1765 20.7622 14.2377 21.0302 14.3108L21.0303 14.3108L21.0303 14.3108C21.8344 14.5301 23.0312 14.8565 24.1464 14.9381C25.6333 15.0469 26.8664 14.5029 27.3016 13.9226C26.3809 14.0377 25.5287 13.9245 23.912 13.7099L23.912 13.7099C23.4908 13.654 23.0178 13.5911 22.4781 13.5237ZM5.36032 11.1664C4.92512 11.0696 3.80085 10.9052 2.64033 10.8762C1.18966 10.84 -1.20393 10.5136 -2.50952 9.02663H-1.05886C-0.501082 9.16608 0.224248 9.30552 1.11713 9.47718C1.15312 9.4841 1.18939 9.49107 1.22593 9.4981C2.16886 9.67943 4.27232 10.4048 5.36032 11.1664Z",
    fill: "#FF0073"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonity);
export default __webpack_public_path__ + "static/media/ionity.898e7873a7b9cb648ffb9a9039252907.svg";
export { ForwardRef as ReactComponent };